import {useEffect} from 'react';
import {useDeviceSize} from './../theme/helpers';
import {logout} from '../../redux/actions/login';
import {useDialog} from '../components/modal/dialog';
import {useAppDispatch} from '../../redux';
import {DeviceSize} from '../theme/helpers';
import {useNavigation} from '@react-navigation/native';
import {useModal} from '../components/modal';
import {Screens} from '../routing';

export const useLogoutDialog = (): (() => Promise<void>) => {
  const dialog = useDialog();
  const dispatch = useAppDispatch();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const modal = useModal();

  // Move modal.clear() into useEffect to avoid setState during render
  useEffect(() => {
    modal.clear();
  }, []);

  return async () => {
    dialog.showDialog({
      message: 'Вы действительно хотите выйти?',
      actions: [
        {
          title: 'Да',
          type: 'primary',
          closeModal: true,
          onPress: () => {
            dispatch(logout());
            navigation.reset({
              index: 1,
              routes: [{name: Screens.Main}, {name: Screens.Profile}],
            });
          },
        },
        {
          title: 'Нет',
          type: 'transparent',
          closeModal: true,
        },
      ],
      messageStyle: deviceSize === DeviceSize.desktop ? {marginBottom: 42} : {marginBottom: 30},
    });
  };
};
